import React from 'react';
import { ShoppingCart } from 'lucide-react';
export function ViewCart() {
  return <div className="space-y-4" data-id="element-2401">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2402">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2403">
          Shopping Cart
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2404">
          Review items in your cart before checkout.
        </p>
      </div>
      <p className="text-sm text-slate-600" data-id="element-2405">Your cart is now empty</p>
    </div>;
}